<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseId"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                        >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.area" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddress" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.masterName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅联系方式">
                <a-input v-model.trim="queryParam.masterPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单子状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                <a-select v-model="queryParam.substate" :allowClear="true">
                  <a-select-option v-for="type in order_substate" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="问题类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.problemType" :allowClear="true">
                  <a-select-option v-for="type in pendingMatterMenu" :title="type.name" :key="type.code">{{
                    type.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="问题内容" style="margin-left: 30px">
                <a-input v-model.trim="queryParam.problemContent" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24">
                <a-form-item>
                  <a-col :md="5" :sm="24" v-if="manageTime">
                    <a-select style="width: 100%; margin-left: 39px" v-model="queryParam.timeType" :allowClear="true">
                      <a-select-option value="0" title="投诉时间"> 投诉时间 </a-select-option>
                      <a-select-option value="1" title="开始处理时间"> 开始处理时间 </a-select-option>
                      <a-select-option value="2" title="处理完成时间"> 处理完成时间 </a-select-option>
                      <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24" v-else>
                    <a-select style="width: 100%; margin-left: 39px" v-model="queryParam.timeType" :allowClear="true">
                      <a-select-option value="0" title="投诉时间"> 投诉时间</a-select-option>
                      <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="10" :sm="24">
                    <a-range-picker
                      style="width: 100%; margin-left: 39px"
                      v-model="dateString"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                      }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['开始时间', '结束时间']"
                      @change="onChangerangepicker"
                    />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="处理情况" style="margin-left: 26px">
                  <a-select :allowClear="true" v-model="queryParam.handleStatus">
                    <a-select-option value="0" title="待处理"> 待处理 </a-select-option>
                    <a-select-option value="1" title="处理中"> 处理中 </a-select-option>
                    <a-select-option value="2" title="待确认"> 待确认 </a-select-option>
                    <a-select-option value="3" title="结束"> 结束 </a-select-option>
                    <a-select-option value="9" title="撤单"> 撤单 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="处理人" style="margin-left: 45px">
                  <a-input v-model.trim="queryParam.handler" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="申请人" style="margin-left: 39px">
                  <a-input v-model.trim="queryParam.feedbackMan" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="当前协助人" style="margin-left: 13px">
                  <a-input v-model.trim="queryParam.helper" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="订单负责人" style="margin-left: 15px">
                  <a-select v-model="queryParam.orderPrincipal">
                    <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                      type.userName
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="manageTime">
                <a-row :gutter="24">
                  <a-form-item label="处理时长" style="margin-left: 39px">
                    <a-col :span="6">
                      <a-input placeholder="最小值" v-model.trim="queryParam.handleStartTime" />
                    </a-col>
                    <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                    <a-col :span="6">
                      <a-input placeholder="最大值" v-model.trim="queryParam.handleEndTime" />
                    </a-col>
                    <a-col :md="10" :sm="24">
                      <a-select default-value="h" :allowClear="true" v-model="queryParam.handleTimeType">
                        <a-select-option value="h" title="小时"> 小时 </a-select-option>
                        <a-select-option value="d" title="天"> 天 </a-select-option>
                        <a-select-option value="m" title="分钟"> 分钟 </a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :md="6" :sm="24" v-if="manageTime">
                <a-row :gutter="24">
                  <a-form-item label="总处理时长" style="margin-left: 13px">
                    <a-col :span="6">
                      <a-input placeholder="最小值" v-model="queryParam.sumHandleStartTime" />
                    </a-col>
                    <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                    <a-col :span="6">
                      <a-input placeholder="最大值" v-model.trim="queryParam.sumHandleEndTime" />
                    </a-col>
                    <a-col :md="10" :sm="24">
                      <a-select default-value="h" :allowClear="true" v-model="queryParam.sumHandleTimeType">
                        <a-select-option value="h" title="小时"> 小时 </a-select-option>
                        <a-select-option value="d" title="天"> 天 </a-select-option>
                        <a-select-option value="m" title="分钟"> 分钟 </a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="feedbackexport" @click="exceptExcel"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-divider />
          <div class="table-operator"></div>
          <!--    表格内容-->
          <s-table size="default" ref="table" :columns="columns" :data="loadData" bordered :scroll="{ x: 4500 }">
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a v-if="details" @click="detailsView(record)">查看</a>
              <a-divider type="vertical" v-if="record.identification != 1 && manage" />
              <a v-if="record.identification != 1 && manage" @click="problemsDealing(record)">处理</a>
              <a-divider v-if="dispatcher" type="vertical" />
              <a
                v-if="dispatcher && (record.handleStatus == '处理中' || record.handleStatus == '待处理')"
                @click="problemsTransfer(record)"
                >转派</a
              >
              <a-divider
                type="vertical"
                v-if="questionList && (record.handleStatus == '处理中' || record.handleStatus == '待处理')"
              />
              <a v-if="questionList" @click="resume(record)">履历</a>
            </span>
            <span slot="contents" slot-scope="text, record" style="white-space: normal">
              {{ text }}
            </span>
          </s-table>
        </a-form>
      </div>
      <a-modal v-model="transferible" @ok="addtransfer()" title="转派" :width="600">
        <a-form :form="transferform">
          <a-row>
            <a-col>
              <a-form-item style="display: none">
                <a-input v-decorator="['feedbackHeaderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转派角色">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="onChangecomplaint"
                  :filterOption="filterOption"
                  style="width: 300px"
                  :allowClear="true"
                  v-decorator="['roleCode', { rules: [{ required: true, message: '请选择转派角色!' }] }]"
                >
                  <a-select-option v-for="type in pendingMattersRoleList" :key="type.code"
                    >{{ type.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="dealingible" title="处理" :width="600" footer="">
        <a-form :form="dealingform" v-if="this.feedbackInfo">
          <a-row>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
                {{ this.feedbackInfo.matterName }}
              </a-form-item>
              <div v-for="(tab, index) in feedbackInfo.itemInfos">
                <div v-if="tab.type == 1">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                    {{ tab.contents }}
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                    <div class="upload">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="tab.arrList"
                        :headers="headers"
                        @preview="handlePreview"
                      >
                      </a-upload>
                    </div>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="视频">
                    <div style="display: flex; flex-direction: row; width: 100%; flex-wrap: wrap">
                      <div v-for="(item, i) in tab.videos">
                        <video
                          class="video"
                          :key="index"
                          :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item"
                          controls
                        ></video>
                      </div>
                    </div>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申诉人">
                    <span> {{ tab.createName }}</span>
                    <span style="margin-left: 25px">申请时间: {{ tab.createTime }}</span>
                  </a-form-item>
                </div>
                <div v-if="tab.type == 1" style="border: 1px solid #ccc"></div>
                <div v-if="tab.type == 2">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理回复">
                    {{ tab.contents }}
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                    <div class="upload">
                      <a-upload
                        :action="uploadUrlb"
                        listType="picture-card"
                        :fileList="tab.arrList"
                        :headers="headers"
                        @preview="handlePreview"
                      >
                      </a-upload>
                    </div>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
                    <span> {{ tab.createName }}</span>
                    <span style="margin-left: 25px">申请时间: {{ tab.createTime }}</span>
                  </a-form-item>
                  <div v-if="tab.type == 2" style="border: 1px solid #ccc"></div>
                </div>
                <div></div>
              </div>
              <a-form :form="replyproblemsform">
                <div v-if="startProcessingible" style="margin: 20px">
                  <a-form-item style="display: none">
                    <a-input v-decorator="['feedbackHeaderId']" />
                  </a-form-item>
                  <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    :label="appealProcessingible ? '申诉内容' : '处理回复'"
                  >
                    <a-input
                      v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                      type="textarea"
                    />
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
                    <a-upload
                      name="file"
                      :multiple="true"
                      accept="image/*"
                      :action="currencyuploadUrl"
                      list-type="picture-card"
                      class="avatar-uploader"
                      :file-list="dealinglist"
                      :headers="headers"
                      :before-upload="beforeUpload"
                      @change="dealingChange"
                      @preview="handlePreview"
                    >
                      <a-icon type="upload" />
                      <div class="ant-upload-text">图片</div>
                    </a-upload>
                  </a-form-item>
                </div>
              </a-form>
              <div style="text-align: center">
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="updateFeedback"
                  v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                  >修改</a-button
                >
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="revoke"
                  v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                  >撤回
                </a-button>
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="startProcessing"
                  v-if="!startProcessingible && !processingCompletedible && !appealProcessingible && !detailsViewible"
                  >处理</a-button
                >
              </div>
              <div style="text-align: center" v-if="startProcessingible && !appealProcessingible">
                <a-button type="primary" style="margin: 20px" @click="problemsTransfer(feedbackInfo)">转派 </a-button>
                <a-button type="primary" style="margin: 20px" @click="replyproblems">回复</a-button>
                <a-button type="primary" style="margin: 20px" @click="processingCompleted">处理完成 </a-button>
              </div>
              <div style="text-align: center" v-if="processingCompletedible && !startProcessingible">
                <a-button type="primary" style="margin: 20px" @click="endProcessing">接受处理意见 </a-button>
                <a-button type="primary" style="margin: 20px" @click="appealProcessing">申诉</a-button>
              </div>
              <div style="text-align: center" v-if="appealProcessingible">
                <a-button type="primary" style="margin: 20px" @click="appealProcessingsubmit">提交 </a-button>
                <a-button type="primary" style="margin: 20px" @click="appealProcessingcancel">取消</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="resumeible" title="履历" :width="600" footer="">
        <a-form :form="resumeform" v-if="pendingMattersResume">
          <a-row v-for="(tab, index) in pendingMattersResume">
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                {{ tab.content }}
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
                {{ tab.createName }}
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
                {{ tab.createTime }}
              </a-form-item>

              <div v-if="index != pendingMattersResume.length - 1" style="border: 1px solid #ccc"></div>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="updateproblemible" @ok="updateproblem()" title="修改" :width="600">
        <a-form :form="updateproblemform">
          <a-row>
            <a-col>
              <a-form-item style="display: none">
                <a-input v-decorator="['feedbackHeaderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
                <a-input v-decorator="['matterName']" disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                <a-input
                  v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                  type="textarea"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
                <a-upload
                  name="file"
                  :multiple="true"
                  :action="currencyuploadUrl"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :file-list="updatepiclist"
                  :headers="headers"
                  @change="updatehandleChange"
                  @preview="handlePreview"
                >
                  <!--<div v-if="updatepiclist.length < 1">-->
                  <a-icon type="upload" />
                  <div class="ant-upload-text">图片</div>
                  <!--</div>-->
                </a-upload>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
                <a-input v-decorator="['initiatorName']" disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
                <a-input v-decorator="['handleStartTime']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal title="撤回" v-model="deleteible" @ok="deleteOK">
        <p>此操作将确认撤回问题反馈，是否继续？</p>
      </a-modal>
      <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
        <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
      </a-modal>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
import {
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getList,
  getOrderDetail,
  getfindByDeptId,
  getfinddictAll,
} from '@/api/order/orderList'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import {
  getfeedbacklist,
  getPendingMatterMenu,
  getFeedbackInfo,
  getPendingMattersRoleList,
  gettransfer,
  getPendingMattersResume,
  getupdateFeedback,
  getrevokeFeedback,
  getstartProcessing,
  getreply,
  getprocessingCompleted,
  getendProcessing,
  getappeal,
  exportFeedbackOrder,
} from '@/api/order/feedback'
import { getAccessoryOrderlist, getselectstore, getdeliverGoods, getAccessoryNumber } from '@/api/order/PartsOrder'
import { STable } from '@/components'
import pick from 'lodash.pick'
import _ from 'lodash'
import NoAuthority from '../enterprise/NoAuthority'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'PartsOrder',
  components: {
    STable,
    NoAuthority,
    // 注册弹框组件
  },
  data() {
    return {
      arrList: [],
      updatepiclist: [],
      previewVisible: false,
      Ifstatus: false,
      dateString: '',
      previewImage: '',
      previewimgible: false,
      previewimgurl: '',
      token: Vue.ls.get(ACCESS_TOKEN),
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=feedback',
      process: process.env.VUE_APP_API_BASE_URL + '/dfs/download',
      // 查看问题详情
      details: checkPermission('feedback:details'),
      // 处理
      manage: checkPermission('feedback:manage'),
      // 转派
      dispatcher: checkPermission('feedback:dispatcher'),
      // 问题履历
      questionList: checkPermission('questionList'),
      // 导出
      feedbackexport: checkPermission('feedback:export'),
      //查看处理时长
      complainTime: checkPermission('complainTime'),
      queryList: checkPermission('order:feedBack:query:list'),
      manageTime: checkPermission('manageTime'),
      findByDeptId: [],
      order_substate: [],
      defaultFileList: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '处理情况',
          dataIndex: 'handleStatus',
          align: 'center',
        },
        {
          title: '问题类型',
          dataIndex: 'problemType',
          align: 'center',
        },
        {
          title: '问题内容',
          dataIndex: 'contents',
          scopedSlots: { customRender: 'contents' },
        },
        {
          title: '状态栏',
          dataIndex: 'statusArea',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '锁企简称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'substate',
          align: 'center',
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          align: 'center',
        },
        {
          title: '申请人联系方式',
          dataIndex: 'applicantPhone',
          align: 'center',
        },
        {
          title: '申请时间',
          dataIndex: 'applicantTime',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterPrincipal',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '当前协助人',
          dataIndex: 'assistingPeople',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'province',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone',
          align: 'center',
        },
        {
          title: '当前处理人',
          dataIndex: 'deal',
          align: 'center',
        },
        {
          title: '处理时长',
          dataIndex: 'dealLongTime',
          align: 'center',
        },
        {
          title: '开始处理时间',
          dataIndex: 'dealStartTime',
          align: 'center',
        },
        {
          title: '处理完成时间',
          dataIndex: 'handle',
          align: 'center',
        },
        {
          title: '总处理时长',
          dataIndex: 'collectDealLongTime',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
      ],
      uncolumns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '处理情况',
          dataIndex: 'handleStatus',
          align: 'center',
        },
        {
          title: '问题类型',
          dataIndex: 'problemType',
          align: 'center',
        },
        {
          title: '问题内容',
          dataIndex: 'contents',
          scopedSlots: { customRender: 'contents' },
        },
        {
          title: '状态栏',
          dataIndex: 'statusArea',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'substate',
          align: 'center',
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          align: 'center',
        },
        {
          title: '申请人联系方式',
          dataIndex: 'applicantPhone',
          align: 'center',
        },
        {
          title: '申请时间',
          dataIndex: 'applicantTime',
          align: 'center',
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterPrincipal',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '当前协助人',
          dataIndex: 'assistingPeople',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'province',
          // align:'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone',
          align: 'center',
        },
        {
          title: '当前处理人',
          dataIndex: 'deal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
      ],
      loadData: (parameter) => {
        return getfeedbacklist(Object.assign(parameter, this.queryParam))
      },
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      dtoList: [],
      // 字典为订单状态,
      order_status: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // 企业名称
      selectCombox: [],
      getselectstoreList: [],
      dtoListtab: {},
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      pendingMatterMenu: [],
      transferible: false,
      transferform: this.$form.createForm(this),
      dealingform: this.$form.createForm(this),
      resumeform: this.$form.createForm(this),
      updateproblemform: this.$form.createForm(this),
      replyproblemsform: this.$form.createForm(this),
      // 转派 表格
      ransfertrecord: '',
      pendingMattersRoleList: [],
      feedbackInfo: '',
      dealingible: false,
      updateproblemible: false,
      resumeible: false,
      deleteible: false,
      startProcessingible: false,
      processingCompletedible: false,
      appealProcessingible: false,
      detailsViewible: false,
      pendingMattersResume: [],
      dealinglist: [],
    }
  },

  async created() {
    if (!this.manageTime) {
      var newarry = []
      var titlearry = ['处理时长', '总处理时长', '开始处理时间', '处理完成时间']
      for (let i in this.columns) {
        if (titlearry.indexOf(this.columns[i].title) == -1) {
          newarry.push(this.columns[i])
        }
      }
      this.columns = newarry
    }
    let dictTypes = ['install_type', 'order_status', 'order_substate']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.installTypes = res.install_type
      this.order_status = res.order_status
      this.order_substate = res.order_substate
    })
    if (!this.complainTime) {
      this.columns = this.uncolumns
    }
    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
    await getPendingMatterMenu({ matterTypeCode: 'feedback' }).then((res) => {
      if (res.code === 0) {
        this.pendingMatterMenu = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    this.getselectstoreList = []
    await getselectstore().then((res) => {
      if (res.code === 0) {
        this.getselectstoreList = res.rows
        // console.log(res.rows)
      } else {
        this.$message.error(res.msg)
      }
    })
    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    // 企业名称
    this.selectCombox = []
    // isAuthority 1   数据隔离
    await getselectCombox({ isAuthority: 1 }).then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
        // console.log(this.selectCombox)
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    // SetOptionTitle(){
    //   var selects = document.getElementsByTagName("select");
    //   if (selects.length > 0) {
    //     for (var i = 0; i < selects.length; i++) {
    //       var options = selects[i].options;
    //       if (selects[i].options.length > 0) {
    //         for (var j = 0; j < options.length; j++) {
    //           if (options[j].title == "")
    //             options[j].title = options[j].text;
    //         }
    //       }
    //     }
    //   }
    // },
    empty() {
      this.queryParam = {}
      this.dateString = ''
    },
    moment,
    updatehandleChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片')
      } else {
        //console.log(info.fileList)
        this.updatepiclist = info.fileList
      }

      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    dealingChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片!')
      } else {
        this.dealinglist = info.fileList
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },

    async handlePreview(file) {
      //
      console.log('file', file)
      if (file.response) {
        this.previewImage =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.previewImage =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.$nextTick(() => {
        this.previewVisible = true
      })
    },

    previewhandleCancel() {
      this.previewVisible = false
    },

    exceptExcel() {
      console.log('导出')
      var str = process.env.VUE_APP_API_BASE_URL + '/order/feedback/exportFeedbackOrder?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
    },
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 申诉
    appealProcessing() {
      this.dealinglist = []
      this.appealProcessingible = true
      this.startProcessingible = true
      setTimeout(() => {
        this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
      }, 100)
    },
    // 取消申诉
    appealProcessingcancel() {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = true
    },
    // 申诉确定
    appealProcessingsubmit() {
      this.replyproblemsform.validateFields((err, values) => {
        values.headerId = values.feedbackHeaderId
        let arr = []
        this.dealinglist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
          console.log(arr)
        })
        values.picUrlList = arr
        if (!err) {
          getappeal(values).then((res) => {
            // console.log(res)
            if (res.code === 0) {
              this.replyproblemsform.setFieldsValue({
                contents: '',
              })
              this.dealinglist = []
              this.$message.success(res.msg)
              this.$refs.table.refresh()
              this.appealProcessingible = false
              this.startProcessingible = true
              this.interfaceReset(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },

    // 开始处理
    startProcessing() {
      getstartProcessing({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then((res) => {
        if (res.code === 0) {
          this.startProcessingible = true
          this.$refs.table.refresh()
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    // 回复
    replyproblems() {
      this.startProcessing()
      this.replyproblemsform.validateFields((err, values) => {
        // console.log(values)
        let arr = []
        this.dealinglist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
          console.log(arr)
        })
        values.picUrlList = arr
        if (!err) {
          getreply(values).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg)
              this.$refs.table.refresh()
              this.replyproblemsform.setFieldsValue({
                contents: '',
              })
              this.dealinglist = []
              this.startProcessing(this.feedbackInfo.feedbackHeaderId)
              this.interfaceReset(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 处理完成
    processingCompleted() {
      getprocessingCompleted({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then((res) => {
        if (res.code === 0) {
          this.$refs.table.refresh()
          this.startProcessingible = false
          this.processingCompletedible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 接受处理意见
    endProcessing() {
      getendProcessing({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then((res) => {
        if (res.code === 0) {
          this.$refs.table.refresh()
          this.$message.success(res.msg)
          this.dealingible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 确定撤回
    deleteOK() {
      getrevokeFeedback({ feedbackHeaderId: this.feedbackInfo.feedbackHeaderId }).then((res) => {
        // console.log(res)
        if (res.code === 0) {
          this.deleteible = false
          this.$refs.table.refresh()
          this.dealingible = false
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 撤回
    revoke() {
      this.deleteible = true
    },
    // 修改弹框确定
    updateproblem() {
      this.updateproblemform.validateFields((err, values) => {
        values.headerId = values.feedbackHeaderId
        let arr = []

        this.updatepiclist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              let obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
              //console.log(obj)
            }
          } else {
            tab.thumbUrl = ''
          }
          arr.push(JSON.stringify(tab))
        })
        console.log(arr)
        values.picUrlList = arr
        if (!err) {
          getupdateFeedback(values).then((res) => {
            if (res.code === 0) {
              this.updateproblemible = false
              this.dealingible = false
              this.$refs.table.refresh(true)
              this.$message.success(res.msg)
              //this.startProcessing(this.feedbackInfo.feedbackHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 修改
    updateFeedback() {
      let that = this
      this.updatepiclist = []
      this.updateproblemform.resetFields()
      setTimeout(() => {
        this.updateproblemform.setFieldsValue(
          pick(this.feedbackInfo, 'feedbackHeaderId', 'matterName', 'initiatorName', 'handleStartTime')
        )
        this.updateproblemform.setFieldsValue(pick(this.feedbackInfo.itemInfos[0], 'contents'))
      }, 100)
      console.log(this.feedbackInfo.itemInfos)
      // this.feedbackInfo.itemInfos[0].arrList.forEach(item=>{
      //   item.thumbUrl=''
      // })
      // arr.push(JSON.stringify( tab ))
      this.updatepiclist = this.feedbackInfo.itemInfos[0].arrList
      this.updateproblemible = true
    },
    // 履历
    resume(record) {
      getPendingMattersResume({ pendingMattersRecordId: record.feedbackHeaderId, matterCode: record.matterCode }).then(
        (res) => {
          if (res.code === 0) {
            this.resumeible = true
            this.pendingMattersResume = res.data
            console.log(this.pendingMattersResume)
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 转派确定
    addtransfer() {
      this.transferform.validateFields((err, values) => {
        if (!err) {
          gettransfer(values).then((res) => {
            if (res.code === 0) {
              this.$refs.table.refresh()
              this.$message.success(res.msg)
              this.transferible = false
              // this.dealingible=false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 转派 表格
    problemsTransfer(record) {
      this.ransfertrecord = record
      console.log(record)
      this.transferform.resetFields()
      setTimeout(() => {
        this.transferform.setFieldsValue({
          feedbackHeaderId: record.feedbackHeaderId,
        })
      }, 100)
      getPendingMattersRoleList().then((res) => {
        if (res.code === 0) {
          this.pendingMattersRoleList = res.data
          this.transferible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    interfaceReset(id) {
      getFeedbackInfo({ feedbackHeaderId: id }).then((res) => {
        let arr = {}
        let that = this
        if (res.code === 0) {
          this.feedbackInfo = res.data
          this.feedbackInfo.itemInfos.forEach((item) => {
            item.arrList = []
            if (item.pics) {
              item.pics.forEach((tab) => {
                console.log(tab)
                if (tab.indexOf(':') == -1) {
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      tab +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: tab,
                        thumbUrl: data,
                        url: tab,
                        status: 'done',
                      })
                    }
                  )
                } else {
                  arr = JSON.parse(tab)
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      arr.url +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: arr.uid,
                        thumbUrl: data,
                        url: arr.url,
                        status: 'done',
                      })
                    }
                  )
                }
              })
            }
          })
          this.dealingible = true
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(pick(this.feedbackInfo, 'feedbackHeaderId'))
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 处理 表格
    problemsDealing(record) {
      this.dealingform.resetFields()
      this.replyproblemsform.setFieldsValue({
        contents: '',
      })
      this.dealinglist = []
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = false
      this.interfaceReset(record.feedbackHeaderId)
      if (record.handleStatus == '处理中') {
        this.startProcessingible = true
        this.appealProcessingible = false
      } else if (record.handleStatus == '待确认') {
        this.startProcessingible = false
        this.processingCompletedible = true
      }
    },
    detailsView(record) {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = true
      let that = this
      getFeedbackInfo({ feedbackHeaderId: record.feedbackHeaderId }).then((res) => {
        if (res.code === 0) {
          this.feedbackInfo = res.data
          this.feedbackInfo.itemInfos.forEach((item) => {
            item.arrList = []
            if (item.pics) {
              item.pics.forEach((tab) => {
                console.log(tab)
                if (tab.indexOf(':') == -1) {
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      tab +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: tab,
                        thumbUrl: data,
                        url: tab,
                        status: 'done',
                      })
                    }
                  )
                } else {
                  let arr = JSON.parse(tab)
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      arr.url +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: arr.uid,
                        thumbUrl: data,
                        url: arr.url,
                        status: 'done',
                      })
                    }
                  )
                }
              })
            }
          })
          this.dealingible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangerangepicker(date, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //将图片转换为Base64
    getImgToBase64(url, callback) {
      let canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        let dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
  },
}
</script>
<style scoped>
/deep/ .upload .anticon anticon-delete {
  display: none;
}
.video {
  width: 140px;
  height: 180px;
  margin: 5px;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
</style>
